import {
    Legend,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip as ReChartsTooltip,
    ComposedChart,
    ResponsiveContainer, Area, LineChart, Scatter, ReferenceLine
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbDangerousStringToDate, bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbErrorSection, bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory,
    bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Badge} from "reactstrap";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";
import EarlyAccessWrapper from "../settings/EarlyAccessWrapper";

export const testHistoryData = [
    {
        "cycle": "02c8fe2c-943a-4902-ad0b-65d91c84d923",
        "cycle_date": "2022-03-11T04:22:26",
        "score": 6.2,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 5.0,
        "confidence_high": 8.7
    },
    {
        "cycle": "0439ba50-1b95-4105-8d4d-1140c246bddc",
        "cycle_date": "2022-01-22T04:18:49",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "068b4ed8-1d17-4425-9229-59b49f425558",
        "cycle_date": "2022-02-14T16:17:30",
        "score": 6.2,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 5.0,
        "confidence_high": 8.7
    },
    {
        "cycle": "13912a7d-c411-4b31-b691-d834fcf768ac",
        "cycle_date": "2022-06-09T04:31:03",
        "score": 5.0,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.8,
        "confidence_high": 6.5
    },
    {
        "cycle": "1bec58ff-6145-4c22-9022-bd81c6ffe4b7",
        "cycle_date": "2022-01-28T04:19:26",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "22702d6e-6ad1-4c74-a249-5f6702a7ca9f",
        "cycle_date": "2022-08-01T15:07:16",
        "score": 4.3,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.1,
        "confidence_high": 5.8
    },
    {
        "cycle": "22998281-b37e-4a94-ab6c-c3a178960444",
        "cycle_date": "2022-04-10T04:26:56",
        "score": 5.9,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.7,
        "confidence_high": 7.4
    },
    {
        "cycle": "23df723a-489a-45b5-80e8-40f48d4f505b",
        "cycle_date": "2021-12-09T13:24:31",
        "score": 5.8,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.6,
        "confidence_high": 8.2
    },
    {
        "cycle": "26fe8483-7843-49ba-b42e-ee209a71d54b",
        "cycle_date": "2022-01-10T04:17:11",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "2dda108a-9712-4b75-b447-9de4bcc472d9",
        "cycle_date": "2022-04-28T04:28:12",
        "score": 5.6,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.4,
        "confidence_high": 7.0
    },
    {
        "cycle": "397ed71e-8ab2-4d88-98ef-85f53fabe5c1",
        "cycle_date": "2022-07-21T04:32:53",
        "score": 4.5,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.3,
        "confidence_high": 6.0
    },
    {
        "cycle": "3a945668-00e8-41f7-9ef4-40b07d44cdac",
        "cycle_date": "2022-02-21T04:21:10",
        "score": 6.2,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 5.0,
        "confidence_high": 8.7
    },
    {
        "cycle": "475158eb-efff-482e-9464-db5dffeeaf9e",
        "cycle_date": "2022-05-10T16:10:47",
        "score": 5.4,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.2,
        "confidence_high": 6.9
    },
    {
        "cycle": "47b7b71c-d062-40fb-bf4d-9872c5716ca5",
        "cycle_date": "2022-03-24T18:03:58",
        "score": 6.1,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.9,
        "confidence_high": 7.5
    },
    {
        "cycle": "499ea305-2c49-4a10-bae5-15a99b3a1a9f",
        "cycle_date": "2022-01-16T04:16:43",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "527ff563-be0b-49d6-9bb7-50af31fb0bf2",
        "cycle_date": "2022-05-28T04:29:58",
        "score": 5.2,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.0,
        "confidence_high": 6.7
    },
    {
        "cycle": "53c6eee7-fe33-405c-b6e3-7a5ba3b90c16",
        "cycle_date": "2022-02-09T04:20:01",
        "score": 6.2,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 5.0,
        "confidence_high": 8.7
    },
    {
        "cycle": "54dff2be-c77a-43c5-94ad-3fad2f6edf7a",
        "cycle_date": "2022-02-27T04:22:16",
        "score": 6.2,
        "fidelity": {
            "id": 2,
            "name": "moderate fidelity",
            "title_name": "Moderate Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.9
    },
    {
        "cycle": "560af32b-9ac3-4105-8715-22a3a8c811a3",
        "cycle_date": "2022-04-22T13:49:30",
        "score": 5.7,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.5,
        "confidence_high": 7.2
    },
    {
        "cycle": "5d2a696b-2e5f-44d1-806a-e889293586d1",
        "cycle_date": "2022-09-13T04:38:06",
        "score": 3.7,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.5,
        "confidence_high": 5.2
    },
    {
        "cycle": "5e2896d1-7155-42cb-af23-fcf34954b050",
        "cycle_date": "2022-04-04T13:27:19",
        "score": 5.9,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.7,
        "confidence_high": 7.4
    },
    {
        "cycle": "641e80f9-7856-44ad-9c9f-3d6b15fcf156",
        "cycle_date": "2022-07-09T04:31:14",
        "score": 4.6,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 3.4,
        "confidence_high": 6.8
    },
    {
        "cycle": "68f5b919-d3dd-4083-adf2-c95357154bc0",
        "cycle_date": "2022-10-01T04:39:30",
        "score": 3.5,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.3,
        "confidence_high": 5.0
    },
    {
        "cycle": "69686b76-1222-4375-bd35-4f89f48d3d3a",
        "cycle_date": "2022-08-22T13:12:28",
        "score": 4.0,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.8,
        "confidence_high": 5.5
    },
    {
        "cycle": "6d14ed23-242b-4396-9698-768e731a5aeb",
        "cycle_date": "2022-06-17T19:25:31",
        "score": 5.0,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.8,
        "confidence_high": 6.5
    },
    {
        "cycle": "7022f06f-b53e-4dfd-89b5-9ec89f942510",
        "cycle_date": "2021-12-06T17:26:13",
        "score": 5.5,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.4,
        "confidence_high": 8.1
    },
    {
        "cycle": "7154c421-da0c-4b98-8c4a-9ad71f3e1be7",
        "cycle_date": "2022-05-16T04:28:01",
        "score": 5.3,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.1,
        "confidence_high": 6.8
    },
    {
        "cycle": "72af3331-e872-4ba3-888f-ac2788bb2c7b",
        "cycle_date": "2021-12-23T21:48:44",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "73acc79a-7d21-443f-9379-f860321689c2",
        "cycle_date": "2022-03-17T04:24:32",
        "score": 6.1,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.9,
        "confidence_high": 8.6
    },
    {
        "cycle": "76d6dc8a-83c0-4c55-9f09-f778021956e7",
        "cycle_date": "2021-11-24T21:33:39",
        "score": 5.5,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.3,
        "confidence_high": 8.0
    },
    {
        "cycle": "7caccfd7-fafa-46a8-9124-164093308d91",
        "cycle_date": "2021-12-29T04:15:24",
        "score": 6.0,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.8,
        "confidence_high": 8.4
    },
    {
        "cycle": "844f06fa-fc74-4b3c-9d70-d31cce11865f",
        "cycle_date": "2022-09-19T04:38:02",
        "score": 3.7,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.5,
        "confidence_high": 5.2
    },
    {
        "cycle": "8e04aecc-dc86-47f6-96a2-0627f4cc4139",
        "cycle_date": "2022-08-26T04:35:17",
        "score": 4.0,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.8,
        "confidence_high": 5.5
    },
    {
        "cycle": "8ecb40a5-cb69-498f-af39-7a7fc1b0b7fb",
        "cycle_date": "2022-03-05T04:22:27",
        "score": 6.2,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 5.0,
        "confidence_high": 8.7
    },
    {
        "cycle": "9546917d-4853-4e37-a9c3-1b8465b4ca5d",
        "cycle_date": "2022-08-09T00:09:10",
        "score": 4.2,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.0,
        "confidence_high": 5.7
    },
    {
        "cycle": "98d4ed65-f2b3-4c61-8a37-a5bf687c059b",
        "cycle_date": "2021-12-01T06:51:27",
        "score": 5.7,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.5,
        "confidence_high": 8.2
    },
    {
        "cycle": "9fe49d2a-712d-4a94-a494-0cbd4a608619",
        "cycle_date": "2022-08-14T04:33:57",
        "score": 4.1,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.9,
        "confidence_high": 5.5
    },
    {
        "cycle": "a077a34c-9ac6-46a0-a3de-b3466afe160f",
        "cycle_date": "2022-09-01T04:36:34",
        "score": 3.9,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.7,
        "confidence_high": 5.3
    },
    {
        "cycle": "a273423b-802f-446b-a608-de1ae319f0b9",
        "cycle_date": "2022-05-21T15:05:20",
        "score": 5.3,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.1,
        "confidence_high": 6.8
    },
    {
        "cycle": "b0a4a74a-9452-491d-8c7f-1de7b586ff7b",
        "cycle_date": "2022-06-27T04:31:00",
        "score": 4.8,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.6,
        "confidence_high": 6.2
    },
    {
        "cycle": "b3b5f439-f43a-4186-80f6-085e53952c02",
        "cycle_date": "2021-11-01T04:08:46",
        "score": 5.5,
        "fidelity": {
            "id": 1,
            "name": "low fidelity",
            "title_name": "Low Fidelity",
            "description": null
        },
        "confidence_low": 3.8,
        "confidence_high": 8.7
    },
    {
        "cycle": "bc529d58-f145-4146-a853-167805a8bd73",
        "cycle_date": "2022-09-07T04:36:51",
        "score": 3.7,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.5,
        "confidence_high": 5.2
    },
    {
        "cycle": "bdc834b1-be5b-41dd-991a-e8ec5084585c",
        "cycle_date": "2021-12-17T04:14:16",
        "score": 5.9,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.7,
        "confidence_high": 8.4
    },
    {
        "cycle": "c9ac36b6-68bd-4392-8b70-4abb5f8808ad",
        "cycle_date": "2022-09-25T04:41:13",
        "score": 3.5,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 2.3,
        "confidence_high": 5.0
    },
    {
        "cycle": "ce4a04d0-2cfb-4ce8-a4f6-bfc765ed8881",
        "cycle_date": "2021-11-08T04:52:10",
        "score": 5.5,
        "fidelity": {
            "id": 1,
            "name": "low fidelity",
            "title_name": "Low Fidelity",
            "description": null
        },
        "confidence_low": 3.8,
        "confidence_high": 8.7
    },
    {
        "cycle": "d21549e8-86e2-44a8-ac37-933712b14881",
        "cycle_date": "2022-07-25T13:59:14",
        "score": 4.4,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.2,
        "confidence_high": 5.9
    },
    {
        "cycle": "d4af2639-446a-4e85-a013-e004d0679189",
        "cycle_date": "2022-01-04T04:15:59",
        "score": 6.1,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.9,
        "confidence_high": 8.6
    },
    {
        "cycle": "d5fb3212-cdc7-429d-993b-d23f60494b33",
        "cycle_date": "2022-02-03T04:19:07",
        "score": 6.1,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.9,
        "confidence_high": 8.6
    },
    {
        "cycle": "e03f2440-ba4a-4468-8a07-8035dc37fca4",
        "cycle_date": "2022-07-06T14:07:22",
        "score": 4.7,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 3.5,
        "confidence_high": 6.9
    },
    {
        "cycle": "eb84586e-63cf-4f70-9aa5-a72f7f524e5c",
        "cycle_date": "2022-06-21T14:28:42",
        "score": 5.0,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.8,
        "confidence_high": 6.5
    },
    {
        "cycle": "efba58db-3043-49f4-a45d-261c93b52b23",
        "cycle_date": "2022-06-06T22:51:41",
        "score": 5.1,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.9,
        "confidence_high": 6.5
    },
    {
        "cycle": "f15e3b09-fcf4-4ec1-8979-1ce9f1367dcd",
        "cycle_date": "2022-03-29T20:38:37",
        "score": 6.1,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.9,
        "confidence_high": 7.5
    },
    {
        "cycle": "f7740094-d781-448a-afcb-edd09a21c507",
        "cycle_date": "2022-05-06T13:31:47",
        "score": 5.6,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.4,
        "confidence_high": 7.0
    },
    {
        "cycle": "f96f086e-28f6-4d84-906d-7c3511188651",
        "cycle_date": "2022-07-15T04:32:15",
        "score": 4.5,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 3.3,
        "confidence_high": 6.0
    },
    {
        "cycle": "fc5be7ad-1cde-4491-b963-7faebe04dff6",
        "cycle_date": "2021-10-21T04:49:10",
        "score": 5.5,
        "fidelity": {
            "id": 1,
            "name": "low fidelity",
            "title_name": "Low Fidelity",
            "description": null
        },
        "confidence_low": 4.5,
        "confidence_high": 9.0
    },
    {
        "cycle": "fd48eca6-f605-43a4-b281-dd8b47151c09",
        "cycle_date": "2021-11-20T10:08:26",
        "score": 5.5,
        "fidelity": {
            "id": 3,
            "name": "high fidelity",
            "title_name": "High Fidelity",
            "description": null
        },
        "confidence_low": 4.3,
        "confidence_high": 8.0
    },
    {
        "cycle": "fdebc617-a643-4430-9a2d-2c85a4fe7ab7",
        "cycle_date": "2022-04-16T04:29:07",
        "score": 5.9,
        "fidelity": {
            "id": 4,
            "name": "highest fidelity",
            "title_name": "Very High Fidelity",
            "description": null
        },
        "confidence_low": 4.7,
        "confidence_high": 7.4
    }
]

function CustomTooltip({ payload, label, active }) {
    // console.log("tip payload is", payload)
    const safePayload = payload && Array.isArray(payload) && payload[0] ? payload[0].payload : {};
    if (active && safePayload && payload) {
        const isTheNeutralDataPoint = safePayload.isTheNeutralDataPoint; //this data point is special
        return (
            <Widget styleName={`p-1 px-2`}>
                <h3><em>{isTheNeutralDataPoint ? `Before your first BreachRisk™ Score` : `${bbFormattedDateString(label, "shortFullMonth")}`}</em></h3>
                <h1 className="label">{isTheNeutralDataPoint ? `Neutral start: ${parseFloat(safePayload.score).toFixed(1)}` : `BreachRisk™ Score: ${parseFloat(safePayload.score).toFixed(1)}`}</h1>
                {isTheNeutralDataPoint && <h4><em>All companies start with a neutral BreachRisk™ Score of 5.0.</em></h4>}

                {/*<h4 className={"text-center"}>Risk Category:</h4>*/}


                {!isTheNeutralDataPoint &&  <Badge color={bbTranslateBreachRiskScoreToColor(parseFloat(safePayload.score).toFixed(1))}><span style={{fontSize: "larger"}}>{bbTranslateBreachRiskScoreToCategory(parseFloat(safePayload.score).toFixed(1))} Risk</span></Badge> }
                {!isTheNeutralDataPoint &&  <em>Most dangerous threat: {parseFloat(safePayload.vector_score).toFixed(1)}</em> }

                <hr/>
                <p>
                    {/*<Badge color={bbTranslateBreachRiskScoreConfidenceLevelsToFidelityColor(parseFloat(payload[0].payload.confidence_low).toFixed(1), parseFloat(payload[0].payload.confidence_high).toFixed(1))}>*/}
                    {/*    {bbTranslateBreachRiskScoreConfidenceLevelsToFidelityCategory(parseFloat(payload[0].payload.confidence_low).toFixed(1), parseFloat(payload[0].payload.confidence_high).toFixed(1))}*/}
                    {/*</Badge>*/}
                    <BRFidelityBadge cycleObject={safePayload}/> <em>Risk could be: <strong>{parseFloat(safePayload.confidence_low).toFixed(1)}</strong> - <strong>{parseFloat(safePayload.confidence_high).toFixed(1)}</strong></em></p>

                {/*<p className="intro">{getIntroOfPage(label)}</p>*/}
                {/*<p className="desc">Anything you want can be displayed here.</p>*/}
            </Widget>
        );
    }

    return null;
}

const bbTickFormatter = (input) => {
    return bbFormattedDateString(input, 'micro');
}

const RenderLineChart = ({
                             showVectorRiskScore = false,
                             cycleId = null,
                             cycleChangeFunction = null,
                             portfolioView = false,
                         }) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);
    // const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customerInView ? customers[customerInView]: customers[customerInView] : null

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const hasEarlyAccess = EarlyAccessWrapper();
    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;

    let historyData = myEntity
        ? myEntity.history : null;

    // const historyData = testHistoryData;
    const sortedHistoryData = historyData
        ? historyData.sort((a,b) => (bbDangerousStringToDate(a.cycle_date) > bbDangerousStringToDate(b.cycle_date) ? 1 : -1))
        : null;

    //only show the 20 most recent data points
    const totalNumDataPoints = sortedHistoryData ? sortedHistoryData.length : null;
    const numDataPointsToShow = 20;
    if(totalNumDataPoints && totalNumDataPoints > numDataPointsToShow) {
        const numPointsToRemove = totalNumDataPoints - numDataPointsToShow;
        const removedHistoryData = sortedHistoryData.splice(0, numPointsToRemove);
    }

    // let newHistoryReferenceArea = null;

    //if history data is too small, add a point to the front
    // if (historyData && historyData.length < 2 && historyData[0]) {
    //     let copyThisPoint = historyData[0];
    //     // copyThisPoint.cycle_date = (bbDangerousStringToDate(historyData[0].cycle_date) - 31)
    //     historyData = [copyThisPoint].concat(historyData);
    //     historyData = [copyThisPoint].concat(historyData);
    //
    //     newHistoryReferenceArea = <ReferenceArea label = "Unknown Risk Level" x1={bbTickFormatter(copyThisPoint.cycle_date)} x2={bbTickFormatter(historyData[historyData.length - 1].cycle_date)} y1={0} y2={10} stroke="red" strokeOpacity={0.3} />
    // }

    //if there are fewer than 8 data points, put one in the front starting at 5.0 neutral so there are always at least 2 data points and it shows them that without looking we assume a 5.0
    if(sortedHistoryData && sortedHistoryData.length < 8 && sortedHistoryData[0] && !sortedHistoryData[0].isTheNeutralDataPoint) {
        // console.log("Fewer than 8 datapoints detected, adding helper neutral data point for context.", sortedHistoryData)
        // const earliestRealDate = sortedHistoryData[0].cycle_date
        const neutralDataPoint = {
            confidence_high: 10,
            confidence_low: 0,
            cycle: null,
            cycle_date: null,
            score: 5,
            isTheNeutralDataPoint: true,
        };
        sortedHistoryData.unshift(neutralDataPoint)

    }

    const indexOfCycleToView = cycleId
    && sortedHistoryData
        ? sortedHistoryData.findIndex((data)=> data.cycle === cycleId)
        : null;
    const cycleDateForRefLine = indexOfCycleToView
    && sortedHistoryData
    && sortedHistoryData[indexOfCycleToView]
    && sortedHistoryData[indexOfCycleToView].cycle_date
        ? sortedHistoryData[indexOfCycleToView].cycle_date
        : null;

    const defaultLastCycleDateTime = sortedHistoryData
    && sortedHistoryData.length
    && !cycleId
        ? sortedHistoryData[sortedHistoryData.length - 1].cycle_date
        : null;

    const clickChartAndShowCycleDetails = (data, secondSlot) => {
        if(hasPremiumSubscription && !portfolioView){
            console.log("Chart pressed. Data is ", data, secondSlot, "cycleChangeFunction", cycleChangeFunction);
            if (cycleChangeFunction && data && data.payload && data.payload.cycle) {
                cycleChangeFunction(data.payload.cycle);
            }
        } else{
            return null
        }

    }

    console.log("reference line", "cycleId", cycleId,"indexofCycleToView" ,indexOfCycleToView,"cycleDateForRefLine", cycleDateForRefLine, "defaultlastcycledatetime", defaultLastCycleDateTime);

    return <Widget styleName={`p-2 animated fadeIn animation-duration-5 dataTile`} id={"score_history_widget"}>
        <Tooltip disableFocusListener
                 title={"How your BreachRisk™ Score - your risk of a breach - has changed over time. Lower scores are better. The Most Dangerous Threat line shows the threat vector with the highest danger rating; your BreachRisk™ Score is directly influenced by this number, and will trend towards this over time."}>
            <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                           className={`text-muted`}/>
        </Tooltip>
        <div className="row"  id={"tourStepBRHistory"}>
            <div className={"col-12"}>
                <h1 className={"text-center"}>Detailed BreachRisk™ Score History</h1>


            </div>
        </div>
        <div className="row" style={{height: 250}}>
            <div className={"col-12"}>
                {!portfolios || loadingPortfolios[customerIdToUse] ?
                    <Skeleton count={10}/>
                    : !myEntity || loadingPortfoliosError[customerIdToUse] ?
                        <div className={"text-center"}>
                            {bbErrorSection("80px")}
                        </div>
                        :
                            <ResponsiveContainer>
                                <LineChart width={800} height={400} data={sortedHistoryData}
                                               margin={{top: 1, right: 10, left: 2, bottom: 5}}>
                                    {/*<Area type="monotone" dataKey="confidence_upper" stroke="#999999" />*/}
                                    <defs>
                                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#A6A6A6" stopOpacity={0.6}/>
                                            <stop offset="95%" stopColor="#A6A6A6" stopOpacity={0.1}/>
                                        </linearGradient>
                                    </defs>
                                    {cycleId && cycleDateForRefLine && hasPremiumSubscription && !portfolioView
                                        ? <ReferenceLine x={`${cycleDateForRefLine}`} stroke="red" strokeWidth={5} id={"refLineScoreHistoryChart"}/>
                                        : null
                                    }
                                    <Line type="monotone" name="BreachRisk™ Score"
                                          dataKey="score" stroke="#69A5FF" strokeWidth={9}
                                          activeDot={{ r: 8, onClick:  clickChartAndShowCycleDetails }}
                                            id={"score_risk_line"}>
                                    </Line>

                                    {/*{hasEarlyAccess &&*/}
                                        <Line name="Most Dangerous Threat" dataKey="vector_score"
                                              stroke="purple" strokeWidth={2}
                                              id={"most_dangerous_threat_line"}
                                              activeDot={{ r: 8, onClick:clickChartAndShowCycleDetails}}/>
                                    {/*// }*/}

                                    <Line type="monotone" name="Possible Low"  dataKey="confidence_low" stroke="green" activeDot={{ r: 8, onClick:clickChartAndShowCycleDetails }}/>
                                    <Line type="monotone" name="Possible High" dataKey="confidence_high" stroke="red" activeDot={{ r: 8, onClick: clickChartAndShowCycleDetails }}/>
                                    {/*<Area type="monotone" name="Highest Threat Detected" dataKey="vector_score" stroke="#A6A6A6" strokeWidth={3} dot={{ strokeWidth: 1}}*/}
                                    {/*      fillOpacity={1} fill="url(#colorUv)">*/}
                                    {/*    /!*<ErrorBar dataKey="confidence_upper" width={4} strokeWidth={2} stroke="green" direction="y" />*!/*/}
                                    {/*</Area>*/}

                                    {/*<Area type="monotone" dataKey="confidence_lower" stroke="#7784e8" />*/}
                                    <CartesianGrid stroke="#ccc" strokeDasharray="5 5"/>
                                    <ReChartsTooltip content={<CustomTooltip/>}/>
                                    <XAxis dataKey="cycle_date" tickFormatter={bbTickFormatter}/>
                                    <YAxis domain={[0, 10]} ticks={[2, 4, 6, 8, 10]} />
                                    <Legend verticalAlign={"bottom"}/>


                                </LineChart>
                            </ResponsiveContainer>
                }
            </div>

        </div>

    </Widget>
};

export default RenderLineChart;